export const RESET_PASSWORD_CONFIG = {
  EMAIL_MAX_LENGTH: 256,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 20,
  RESEND_COOLDOWN_SECONDS: 60,
  RESEND_LONG_COOLDOWN_SECONDS: 300,
  RESEND_LONG_COOLDOWN_ATTEMPT: 5,
  NEW_PASSWORD_CHECK_DEBOUNCE_MS: 400,
} as const;
